import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';

import { LoginGuard } from '@mediahaven/shared';
import { ShPreloadingStrategyService } from '@stylehaven/components';
import { AuthGuard } from './guards/auth/auth.guard';
import { MediahavenHostNameGuard } from './guards/auth/host-name.guard';

const routes: Routes = [
    {
        path: 'login',
        canActivate: [LoginGuard],
        loadChildren: () => import('@mediahaven/shared').then(module => module.AuthenticationModule)
    },
    {
        path: 'logout',
        loadChildren: () => import('@mediahaven/shared').then(module => module.AuthenticationModule)
    },
    {
        path: 'token',
        redirectTo: 'auth/redirect'
    },
    {
        path: 'auth',
        loadChildren: () => import('@mediahaven/shared').then(m => m.AuthenticationModule)
    },
    {
        path: 'viewer',
        loadChildren: () => import('@stylehaven/components').then(module => module.ViewerModule)
    },
    {
        path: '',
        canActivate: [AuthGuard, MediahavenHostNameGuard],
        canMatch: [AuthGuard],
        loadChildren: () => import('@app/application.module').then(m => m.ApplicationModule)
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];

const routerConfig: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'reload',
    enableTracing: false, // If true, logs the navigation events
    preloadingStrategy: ShPreloadingStrategyService,
    paramsInheritanceStrategy: 'always'
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routerConfig)],
    exports: [RouterModule]
})
export class BootstrapRoutingModule {}
